import { modifyToInstance } from "../../lib/Formatter";

const headerStyle = () => {
    return { borderColor: '#a81933' };
};

const jsonFormatter = (json) => {
    if(json){
        var arr = [];
        json.forEach((field) => {
            arr.push(field.FranchiseRoles.Name);
        });
        return arr.join(", ");
    }
};

export const columns = [
    {    
        dataField: 'FirstName',
        text: 'First Name',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'LastName',
        text: 'Last Name',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'UserName',
        text: 'Username',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'FranchiseUserRoles',
        text: 'Roles',
        sort: true,
        headerStyle: headerStyle,
        formatter: (_cell, row) => modifyToInstance(jsonFormatter(row.FranchiseUserRoles))
    },
    {
        dataField: 'Email',
        text: 'Email',
        sort: true,
        headerStyle: headerStyle
    },
];

export const sorting = [{
    dataField: 'FirstName',
    order: 'asc'
}];